import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {InvoicesService} from "../../data/invoices.service";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";

@Component({
  selector: 'invoice-reject',
  templateUrl: './invoice-reject.component.html',
  styleUrls: ['./invoice-reject.component.scss']
})
export class InvoiceRejectComponent implements OnInit {
  form: FormGroup;

  constructor(
      private formBuilder: FormBuilder,
      private InvoicesService: InvoicesService
  ) { }

  @Input() invoice_id: number;
  @Input() invoiceNumber: string;

  @Output() onClose=new EventEmitter();
  @Output() onSuccess=new EventEmitter();

  ngOnInit(): void {
    this.addControls();
  }
  addControls() {
    this.form = this.formBuilder.group(
        {
          comments: new FormControl('' ),
        }
    );
  }
  get formControls() {
    return this.form.controls;
  }
  save() {
    let data={
      invoice_id: this.invoice_id,
      comments: this.formControls.comments.value
    }
    this.InvoicesService.reject(data).subscribe(
        ()=>{},
        (error)=>console.error(error),
        ()=>this.onSuccess.emit()
    )
  }
  close() {
    this.onClose.emit();
  }
}
